/* eslint-disable */
export default {
  forward: '转接',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
